import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://qyncwbtvfnxgmgulmulp.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF5bmN3YnR2Zm54Z21ndWxtdWxwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg0MzIzMzksImV4cCI6MjA5NDAwODMzOX0.iDZj_uLcDU1pc6YG8_l1dFiO62LlFI3g96qHlYUUk84'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})